<template>
  <div class="noData" :class="{ 'is-top': isTop == true }">
    <img class="img-noData" :src="require('@/assets/noData.png')" fit="cover">
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    isTop: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0.3rem;
  .img-noData {
    width: 5rem;
    height: 3rem;
  }
  p {
    color: #6d6d6d;
  }
}
.is-top {
  margin-top: 0.6rem;
}
</style>
